<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-row justify-center items-center">

            <div class="vx-col p-20">
                <div class="mb-5 text-left">
                    <img src="@/assets/images/logo/logo-w.svg" alt="CFC Solutions"
                         class="fill-current stroke-current text-white inline-block">
                </div>
                <h1 class="d-theme-text-inverse text-2xl md:text-4xl mb-5">Outil de gestion &amp; <br>suivi de
                    facturation</h1>
                <h4 class="d-theme-text-inverse text-opacity-75 font-normal">Le plus court chemin <br>de la facture au
                    règlement</h4>
            </div>

            <div class="vx-col">
                <vx-card>
                    <div slot="no-body" class="full-page-bg-white rounded-lg d-theme-dark-bg">
                        <div class="p-10 login-tabs-container">

                            <div class="vx-card__title mb-4">
                                <h4 class="mb-4">
                                    Réinitialisation du mot de passe
                                </h4>
                                <p>
                                    Veuillez saisir votre nouveau mot de passe:
                                </p>
                            </div>

                            <div>
                                <form action="#" @submit.prevent=""
                                      @keydown.enter="validadeFields ? dorecover(): false">

                                    <vs-input
                                        v-validate="{required : true,regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/}"
                                        data-vv-validate-on="change|input|keyup"
                                        name="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                                        placeholder="votre nouveau mot de passe" v-model="password"
                                        type="password"
                                        ref="password"
                                        class="w-full mt-8"/>
                                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <vs-input
                                        v-validate="{required : true,confirmed: 'password'}"
                                        data-vv-validate-on="change|input|keyup"
                                        name="password_confirmation" icon-no-border icon="icon icon-lock"
                                        icon-pack="feather" placeholder="confirmer votre nouveau mot de passe"
                                        type="password"
                                        v-model="password_confirmation" class="w-full mt-8"/>
                                    <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>

                                    <div class="flex flex-wrap justify-between my-5">
                                        <router-link class="my-2" to="/pages/login"><i
                                            class="far fa-arrow-left mr-2"></i>Retour à la page de login
                                        </router-link>
                                        <vs-button :disabled="!validadeFields" @click="dorecover" class="float-right">
                                            Envoyer
                                        </vs-button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {Validator} from 'vee-validate'

const dict = {
    custom: {
        password: {
            required: 'Merci de saisir un mot de passe',
            regex: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial'
        },
        password_confirmation: {
            required: 'Merci de confirmer votre mot de passe',
            confirmed: 'Les mots de passe ne correspondent pas'
        }
    }
}

// register custom messages
Validator.localize('fr', dict)

export default {
    name: 'ResetPassword',
    data() {
        return {
            password: '',
            password_confirmation: '',
        }
    },
    computed: {
        validadeFields() {
            return this.password && this.password_confirmation
        }
    },
    methods: {
        ...mapActions('user', ['resetpass', 'login']),
        dorecover() {
            this.resetpass({
                token: this.$route.params.token,
                password: this.password,
                password_confirmation: this.password_confirmation
            })
                .then(response => {
                    this.login({email: response.data.email, password: this.password})
                        .then(response => {
                            this.$router.push({name: 'Dashboard'})
                        });
                })
                .catch(error => {
                    this.$vs.notify({
                        title: 'Erreur',
                        text: error.response.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    })
                })
        }
    }
}
</script>

<style>
.login-tabs-container{
    max-width: 380px;
}
</style>
